import React from 'react'
import LoyaltyTierPill from 'components/Luxkit/LoyaltyTierPill'
import TextLink from 'components/Luxkit/TextLink'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import styled from 'styled-components'

const Span = styled.div`
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

function TriplePointTakeoverHeroSubtitle() {
  const [tier] = useCurrentLoyaltyTier()

  return <div>
    Look for <Span><LoyaltyTierPill variant="primary" tier={tier}>Triple Points</LoyaltyTierPill></Span>{' '}
    on select packages! Hurry, limited time only. <TextLink wrap="no-wrap" to="/triple-points">View all offers</TextLink>
  </div>
}

export default TriplePointTakeoverHeroSubtitle
